import { HOW_IT_WORKS_STEPS } from "./marketing-content";

export function MarketingHowItWorks() {
  return (
    <section id="how-it-works" className="container mx-auto px-4 py-20">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">How it works</h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          From signup to day-to-day operations in three clear steps.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {HOW_IT_WORKS_STEPS.map((item) => (
          <div key={item.step} className="p-6 rounded-lg border bg-card relative">
            <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary text-primary-foreground font-semibold">
              {item.step}
            </div>
            <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
            <p className="text-muted-foreground">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
